import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  cancel1xim2hrvjmwpn as cancel,
  Key_instancebefxze3q9f64 as Key_instance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
function PipelineContext$proceed$ref(p0) {
  return constructCallableReference(function *($completion) {
    yield* p0.a4s($completion);
    return Unit_instance;
  }, 0, 9, 219, VOID, [p0]);
}
function SetupRequestContext$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler($this$intercept.x4s_1, PipelineContext$proceed$ref($this$intercept), $completion);
    return Unit_instance;
  }, 2);
}
var SetupRequestContextClass;
function SetupRequestContext() {
  if (SetupRequestContextClass === VOID) {
    class $ {
      p5p(client, handler) {
        var tmp = Phases_getInstance().h5m_1;
        client.f5g_1.b4t(tmp, SetupRequestContext$install$slambda(handler));
      }
      m5m(client, handler) {
        return this.p5p(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequestContext');
    SetupRequestContextClass = $;
  }
  return SetupRequestContextClass;
}
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.ex((cause) => {
    if (!(cause == null)) {
      get_LOGGER().b4u('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel(requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER().b4u('Cancelling request because engine Job completed');
      requestJob.t12();
    }
    return Unit_instance;
  });
  requestJob.ex((it) => {
    handler.sz();
    return Unit_instance;
  });
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.w5m(tmp, HttpRequestLifecycle$lambda$slambda($this$createClientPlugin));
  return Unit_instance;
}
function HttpRequestLifecycle$lambda$slambda($this_createClientPlugin) {
  return constructCallableReference(function *(request, proceed, $completion) {
    var executionContext = SupervisorJob(request.d5i_1);
    attachToClientEngineJob(executionContext, ensureNotNull($this_createClientPlugin.s5m_1.e5g_1.bd(Key_instance)));
    var tmp;
    try {
      request.d5i_1 = executionContext;
      tmp = yield* proceed($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        executionContext.s12(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
    finally {
      executionContext.t12();
    }
    return Unit_instance;
  }, 2);
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
//region block: init
SetupRequestContext_instance = new (SetupRequestContext())();
//endregion
//region block: exports
export {
  get_HttpRequestLifecycle as get_HttpRequestLifecycle1e7j0z243lnj5,
};
//endregion

//# sourceMappingURL=HttpRequestLifecycle.mjs.map
